import * as dd from 'dingtalk-jsapi';//截取地址栏参数
import axios from 'axios';
export function GetQueryString (name) {
  var after = window.location.hash.split("?")[1];
  if (after) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
}
//设置页面title
export function setPageTitle (title) {
  if (title) {
    document.title = title
  }
  //解决钉钉中title展示bug
  if (dd && dd.env.version) {
    dd.ready(function () {
      dd.biz.navigation.setTitle({
        title,
      })
    })
  }
}
//防抖
export function debounce (func, delay) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function handleSearchBaseApi () {
  return new Promise((resolve, reject) => {
    axios.get(`/public.json?t=${new Date().getTime()}`).then(res => {
      if (res.data.length > 0) {
        axios.get(`https://geteway.smartee.cn/Http/HttpRequest?type=${res.data[0].type}&country=${res.data[0].country}`)
          .then(res => {
            localStorage.setItem('BASE_API_1', res.data.BASE_API_1)
            localStorage.setItem('CANVAS_URI', res.data.CANVAS_URI)
            localStorage.setItem('UPLOAD_URI', res.data.UPLOAD_URI)
            resolve()
          })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/other.js